var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBuildingBalanceFullIcon = function SvgBuildingBalanceFullIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#building-balance-full-icon_svg__a)",
    fill: "#004C64"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.735.03c.18-.04.365-.04.545 0 .214.05.398.167.478.218l.02.014 5.73 3.58a.85.85 0 0 1-.452 1.572H1.958a.85.85 0 0 1-.45-1.572L7.236.262l.021-.014c.08-.05.264-.169.478-.217Zm.272 1.756L4.924 3.713h6.166L8.007 1.786ZM3.471 5.981c.47 0 .85.381.85.85v6.05a.85.85 0 0 1-1.701 0v-6.05c0-.469.38-.85.85-.85Zm3.024 0c.47 0 .85.381.85.85v6.05a.85.85 0 0 1-1.7 0v-6.05c0-.469.38-.85.85-.85Zm3.025 0c.47 0 .85.381.85.85v6.05a.85.85 0 0 1-1.701 0v-6.05c0-.469.38-.85.85-.85Zm3.024 0c.47 0 .85.381.85.85v6.05a.85.85 0 1 1-1.7 0v-6.05c0-.469.38-.85.85-.85ZM.352 15.15c0-.47.38-.85.85-.85h13.61a.85.85 0 0 1 0 1.701H1.203a.85.85 0 0 1-.85-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.582 2.095 3.581-.743 2.804.439 1.352 2.5H4.582V2.095Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "building-balance-full-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgBuildingBalanceFullIcon;